import ExceptionTransformer from "@hipo/hipo-exceptions-js";

import {
  GENERIC_ERROR_MESSAGE,
  HIPO_API_ERROR_TYPES,
  HipoApiErrorShape
} from "../../../util/error/errorConstants";
import FetcherError from "../../network/fetcher/FetcherError";

const exceptionTransformer = new ExceptionTransformer(GENERIC_ERROR_MESSAGE);

function isHipoApiErrorShape(error: any): error is HipoApiErrorShape {
  return Boolean(error) && typeof error.fallback_message !== "undefined";
}

function generateErrorMessage(
  error: any,
  options?: {
    skipTypes?: Array<ValueOf<typeof HIPO_API_ERROR_TYPES>>;
    knownErrorKeys?: string[] | null;
  }
) {
  let message = "";

  if (error instanceof Error || error instanceof FetcherError) {
    message = error.message || GENERIC_ERROR_MESSAGE;
  } else if (isHipoApiErrorShape(error)) {
    message = exceptionTransformer.generateErrorMessage(error, options);
  } else if (isHipoApiErrorShape(error?.data)) {
    message = exceptionTransformer.generateErrorMessage(error.data, options);
  }

  return message;
}

export {generateErrorMessage, isHipoApiErrorShape};
